/* Akademie für Lernmethoden – kleine Helfer (Video-/Podcast-Klick-zum-Laden, Einblend-Animation) */
(function () {
  if (window.__aflInit) return;
  window.__aflInit = true;

  var NOTE = 'Mit dem Klick wird der Inhalt von einem externen Anbieter geladen. Dabei werden Daten an diesen übertragen.';

  function enhanceVideo(el) {
    if (el.dataset.aflReady) return;
    el.dataset.aflReady = '1';
    var a = el.querySelector('a');
    if (!a) return;
    var provider = el.dataset.provider;
    var label = provider === 'vimeo' ? 'Video abspielen (Vimeo)' : 'Video abspielen (YouTube)';
    a.innerHTML = '<span>' + label + '</span><span class="afl-video__note">' + NOTE + '</span>';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var id = el.dataset.id, src;
      if (provider === 'youtube') src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      else if (provider === 'youtube-list') src = 'https://www.youtube-nocookie.com/embed/videoseries?list=' + id + '&autoplay=1';
      else if (provider === 'vimeo') src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
      if (!src) { window.open(a.href, '_blank'); return; }
      var f = document.createElement('iframe');
      f.src = src; f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen = true;
      f.title = 'Video';
      el.innerHTML = ''; el.appendChild(f);
    });
  }

  function enhancePodcast(el) {
    if (el.dataset.aflReady) return;
    el.dataset.aflReady = '1';
    var a = el.querySelector('a');
    if (!a) return;
    a.addEventListener('click', function (e) {
      var cfg = el.dataset.config;
      if (!cfg) return;
      e.preventDefault();
      el.innerHTML = '';
      var s = document.createElement('script');
      s.className = 'podigee-podcast-player';
      s.src = 'https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js';
      s.setAttribute('data-configuration', cfg);
      el.appendChild(s);
    });
    var t = a.textContent;
    a.innerHTML = '<span>' + t + '<br><small style="font-weight:400;opacity:.75">' + NOTE + '</small></span>';
  }

  /* Bild-Lightbox für Bilder im Fließtext (ohne eigenen Link) */
  var lb;
  function openLightbox(src, alt) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'afl-lightbox';
      lb.innerHTML = '<button class="afl-lightbox__close" aria-label="Schließen">×</button><img alt="">';
      lb.addEventListener('click', function () { lb.classList.remove('is-open'); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb) lb.classList.remove('is-open'); });
      document.body.appendChild(lb);
    }
    var im = lb.querySelector('img');
    im.src = src.replace(/([?&])width=\d+/, '$1width=2000');
    im.alt = alt || '';
    lb.classList.add('is-open');
  }
  function enhanceImages(root) {
    root.querySelectorAll('.afl-rte figure img, .afl-rte > p img').forEach(function (img) {
      if (img.dataset.aflLb || img.closest('a') || img.closest('.afl-linkcard') || img.closest('.afl-profile')) return;
      img.dataset.aflLb = '1';
      img.classList.add('afl-zoomable');
      img.addEventListener('click', function () { openLightbox(img.currentSrc || img.src, img.alt); });
    });
  }

  function init(root) {
    root = root || document;
    enhanceImages(root);
    root.querySelectorAll('.afl-video[data-id]').forEach(enhanceVideo);
    root.querySelectorAll('.afl-podcast[data-config]').forEach(enhancePodcast);
    var items = root.querySelectorAll('.afl-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
